import { register } from "@rill/loader";
import moment from "moment";

// The days a client has a scheduled workout, as sorted YYYYMMDD numbers. Asks the exercise
// endpoint for the date of each exercise only (no sets, threads or notes): the Readiness Rate
// report needs to know which days were training days, nothing else about them.
register(
  {
    name: "trainingDays",
    meta: ["no-bust", "exercise"],
    ttl: "2 hours",
  },
  async ({ api }, { start, end, proxyAthlete }) => {
    const res = await api("exercise", {
      query: {
        limit: false,
        fields: ["utcDate"],
        utcDate: {
          $gte: Number.parseInt(moment(start).format("YYYYMMDD"), 10),
          $lte: Number.parseInt(moment(end).format("YYYYMMDD"), 10),
        },
        // Same filter as the calendar: unscheduled program exercises carry placeholder dates
        $or: [{ cycle: { $exists: false } }, { "cycle.isScheduled": true }],
        proxyAthlete,
      },
    });
    const exercises = await res.json();
    const days = new Set();
    for (const exercise of exercises) {
      if (Number.isFinite(exercise.utcDate)) days.add(exercise.utcDate);
    }
    return [...days].sort((a, b) => a - b);
  }
);
